var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9997,
    cy: 16.9997,
    r: 14.1667,
    fill: "white",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.499 11.5513C24.874 11.829 24.2014 12.0159 23.496 12.1004C24.2162 11.6686 24.7692 10.9852 25.0293 10.171C24.3561 10.571 23.6088 10.8606 22.8149 11.0175C22.1786 10.3399 21.2714 9.91602 20.269 9.91602C18.3431 9.91602 16.7814 11.4776 16.7814 13.4036C16.7814 13.6767 16.8126 13.943 16.8721 14.1986C13.9732 14.0535 11.4036 12.6647 9.68328 10.5546C9.38296 11.0697 9.21128 11.6686 9.21128 12.3078C9.21128 13.5175 9.82607 14.585 10.7627 15.2106C10.1904 15.1925 9.65325 15.0355 9.18238 14.7743V14.8179C9.18238 16.5082 10.3853 17.9174 11.9798 18.2387C11.6874 18.318 11.3792 18.3611 11.0613 18.3611C10.8364 18.3611 10.6176 18.339 10.4046 18.2982C10.8483 19.6836 12.1368 20.6922 13.6627 20.7205C12.4694 21.6554 10.9656 22.2136 9.3314 22.2136C9.04922 22.2136 8.77157 22.1971 8.49902 22.1643C10.0425 23.1536 11.8756 23.7316 13.8452 23.7316C20.26 23.7316 23.768 18.4171 23.768 13.8088C23.768 13.6575 23.7651 13.5067 23.7578 13.3577C24.44 12.8648 25.0316 12.2505 25.499 11.5513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f3e16abf405a7450e7e066f6d6be7eef.svg";
export { ForwardRef as ReactComponent };